import { MessageSquare, Download } from 'lucide-react';
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChatControlsProps } from '../types/chat.types';
import { TokenCounter } from './TokenCounter';
import { useIsMobile } from '@/hooks/useIsMobile';
import { TOKEN_CONTEXT_LIMIT } from '@/config/appConfig';

export const ChatControls = ({
  onExportTxt,
  onExportPdf,
  onCopyToClipboard,
  onSendFeedback,
  hasMessages,
  hasConversation,
  tokenCount = 0,
  tokenLimit = TOKEN_CONTEXT_LIMIT,
}: ChatControlsProps) => {
  // On mobile, Feedback/Export collapse to icon-only buttons and the token
  // counter becomes a small filling ring instead of a labeled bar.
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-wrap items-center justify-end mt-2 gap-2 gap-y-2">
      {tokenCount > 0 && (
        <TokenCounter tokenCount={tokenCount} limit={tokenLimit} variant={isMobile ? 'ring' : 'bar'} />
      )}
      {hasConversation && (
        <Button
          variant="outline"
          size={isMobile ? 'icon' : 'sm'}
          className={isMobile ? 'h-6 w-6 border-0' : undefined}
          onClick={onSendFeedback}
          aria-label="Send feedback"
          title="Send feedback"
        >
          <MessageSquare className="h-3.5 w-3.5" />
          {!isMobile && 'Send Feedback'}
        </Button>
      )}
      {hasMessages && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              size={isMobile ? 'icon' : 'sm'}
              className={isMobile ? 'h-6 w-6 border-0' : undefined}
              aria-label="Export conversation"
              title="Export conversation"
            >
              <Download className="h-3.5 w-3.5" />
              {!isMobile && 'Export conversation'}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" side="top">
            <DropdownMenuItem onClick={onCopyToClipboard}>
              Copy to clipboard
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onExportTxt}>
              Download as TXT
            </DropdownMenuItem>
            <DropdownMenuItem onClick={onExportPdf}>
              Download as PDF
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};
